var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"categories-list"},_vm._l((_vm.categories),function(category){return _c('Category',{key:category,attrs:{"name":category}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }